import instance from "@/services/api";

export const sbsPartnerAPI = {
  async getSbsPartnerList(params) {
    return await instance()
      .get("/project/sbs_partner/read_all/", { params })
      .then((res) => res?.data);
  },
};
